import * as ValidateModel from '../shared/ValidateModel';
import GraphicTags from "../objects/graphicsLibrary/graphicTags";
import GraphicTag from "../objects/graphicsLibrary/graphicTag";

const fields = {
    ID: 'id',
    NAME: 'name',
    ID_PARENT: 'idParent',
};

class GraphicsLibraryTagsConverter {
    static convertOne = (data: any): GraphicTag => {
        ValidateModel.isObject(data, 'data');
        const {
            [fields.ID]: id,
            [fields.NAME]: name,
            [fields.ID_PARENT]: idParent,
        } = data;
        return new GraphicTag(
            id,
            name,
            idParent,
        );
    };

    static convertAllToArray = (data: any[]): GraphicTag[] => {
        ValidateModel.isArray(data, 'data');
        return data.map((item) => GraphicsLibraryTagsConverter.convertOne(item));
    };

    static convertAll = (data: any[]): GraphicTags => {
        ValidateModel.isArray(data, 'data');
        return new GraphicTags(GraphicsLibraryTagsConverter.convertAllToArray(data));
    }
}

export default GraphicsLibraryTagsConverter;
